<template>
  <div>

    <div>
      <button href="javascript:void(0)" class="id-color disabled:opacity-25" @click="openCreateDistributorPopup"
        :disabled="(preferProduct.distributor_id === null || preferProduct.distributor_id === '')">
        Edit Case Info
      </button>
    </div>

    <jet-dialog-modal :show="isDistributorModel" @close="closeDistributorPopup" :max-width="'3xl'">
      <template #title>
        <div class="flex justify-between items-center text-xl font-bold uppercase">
          {{ getDistributorName() }} Distributor
        </div>
      </template>

      <template #content>
        <div class="max-w-7xl mx-auto space-y-8">

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

            
              <div>
                <label class="block text-sm font-bold mb-1 ">Product Name</label>
                {{ preferProduct.product_name }}
              </div>
              <div>
                <label class="block text-sm font-bold mb-1 ">Manufacturer</label>
                {{ preferProduct.manufacturer ?? '-' }}
              </div>
              <div>
                <label class="block text-sm font-bold mb-1 ">GTIN</label>
                {{ preferProduct.gtin ?? '-' }}
              </div>
              <div>
                <label class="block text-sm font-bold mb-1 ">Manufacturer#</label>
                {{ preferProduct.manufacturer_sku ?? '-' }}
              </div>
              </div>



          <!-- FORM HEADER -->
          <div class="bg-white p-6 shadow rounded-xl space-y-6" v-if="!isCaseExist">
            <!-- Radio Buttons -->
            <div class="space-y-3">
              <label class="block text-sm font-medium">Item Type</label>
              <div class="flex items-center gap-6">
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="radio" name="item_type" v-model="item_type" value="new" class="h-4 w-4">
                  <span>Is New Item</span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer">
                  <input type="radio" name="item_type" v-model="item_type" value="exist" class="h-4 w-4"
                    @click="getDistributorItems">
                  <span>Exist Items</span>
                </label>
              </div>
            </div>
          </div>

          <!-- ITEMS TABLE -->
          <div class="bg-white p-6 shadow rounded-xl " v-if="item_type === 'exist'">
            <h2 class="text-lg font-semibold mb-4">Items List</h2>

            <div class="overflow-auto max-h-96">

              <table class="w-full min-w-max border ">
                <thead class="bg-gray-100 text-sm">
                  <tr>
                    <th class="border px-2 py-2">ACTIONS</th>
                    <th class="border px-2 py-2">Distributor Number</th>

                    <th class="border px-2 py-2">UPC</th>
                    <th class="border px-2 py-2">CASE COST ($)</th>
                    <th class="border px-2 py-2">CASE QTY</th>
                    <th class="border px-2 py-2">CASE WEIGHT</th>
                    <th class="border px-2 py-2">CASE WEIGHT UOM</th>
                    <th class="border px-2 py-2">CASE VOLUME</th>
                    <th class="border px-2 py-2">CASE VOLUME UOM</th>
                    <th class="border px-2 py-2">CASE QTY</th>
                    <th class="border px-2 py-2">SUB CASE QTY</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <tr v-if="items.length === 0">
                    <td colspan="13" class="border px-2 py-2 ">No Items found</td>
                  </tr>
                  <tr v-for="value in items">
                    <td class="border px-2 py-2 text-center">
                      <input type="radio" name="selectedItem" v-model="selectedItem" :value="value" />
                    </td>
                    <td class="border px-2 py-2">{{ value.item_number }}</td>

                    <td class="border px-2 py-2">{{ value.upc }}</td>
                    <td class="border px-2 py-2">{{ value.case_cost }}</td>
                    <td class="border px-2 py-2">{{ value.case_qty }}</td>
                    <td class="border px-2 py-2">{{ value.case_weight }}</td>
                    <td class="border px-2 py-2">{{ value.case_weight_uom }}</td>
                    <td class="border px-2 py-2">{{ value.case_volume }}</td>
                    <td class="border px-2 py-2">{{ value.case_volume_uom }}</td>
                    <td class="border px-2 py-2">{{ value.case_qty }}</td>
                    <td class="border px-2 py-2">{{ value.sub_case_qty }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>


          <!-- FORM TO ADD/EDIT ITEM -->
          <div class="bg-white p-6 shadow rounded-xl space-y-6" v-if="item_type === 'new' || item_type === 'edit'">
            <h2 class="text-lg font-semibold">{{ item_type === 'edit' ? "Edit" : "Add New" }} Item</h2>

            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label class="block text-sm font-medium mb-1 required">Distributor Number</label>
                <input type="text" required v-model="disForm.item_number" class="w-full border px-3 py-2 rounded-lg">
              </div>

              <div>
                <label class="block text-sm font-medium mb-1">UPC</label>
                <input type="text" v-model="disForm.upc" class="w-full border px-3 py-2 rounded-lg">
              </div>

              <div>
                <label class="block text-sm font-medium mb-1">Case Cost ($)</label>
                <input type="text" v-model="disForm.case_cost" class="w-full border px-3 py-2 rounded-lg">
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
              <div>
                <label class="block text-sm font-medium mb-1 required">Case Weight</label>
                <input type="number" min="0" step="1" v-model="disForm.case_weight" class="w-full border px-3 py-2 rounded-lg">
              </div>

              <div>
                <label class="block text-sm font-medium mb-1 required ">Case Weight UOM</label>
                <select v-model="disForm.case_weight_uom" class="w-full border px-3 py-2 rounded-lg">
                  <option value="">-- Select --</option>
                  <option v-for="uom in weight_uoms" :key="uom" :value="uom">{{ uom }}</option>
                </select>
              </div>

              <div>
                <label class="block text-sm font-medium mb-1">Sub Case Weight</label>
                <input type="number" min="0" step="1" v-model="disForm.sub_case_weight" class="w-full border px-3 py-2 rounded-lg">
              </div>

              <div>
                <label class="block text-sm font-medium mb-1 ">Sub Case Weight UOM</label>
                <select v-model="disForm.sub_case_weight_uom" class="w-full border px-3 py-2 rounded-lg">
                  <option value="">-- Select --</option>
                  <option v-for="uom in weight_uoms" :key="uom" :value="uom">{{ uom }}</option>
                </select>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
              <div>
                <label class="block text-sm font-medium mb-1">Case Volume</label>
                <input type="number" min="0" step="1" v-model="disForm.case_volume" class="w-full border px-3 py-2 rounded-lg">
              </div>

              <div>
                <label class="block text-sm font-medium mb-1 ">Case Volume UOM</label>
                <select v-model="disForm.case_volume_uom" class="w-full border px-3 py-2 rounded-lg">
                  <option value="">-- Select --</option>
                  <option v-for="uom in volume_uoms" :key="uom" :value="uom">{{ uom }}</option>
                </select>
              </div>

              <div>
                <label class="block text-sm font-medium mb-1">Sub Case Volume</label>
                <input type="number" min="0" step="1" v-model="disForm.sub_case_volume" class="w-full border px-3 py-2 rounded-lg">
              </div>

              <div>
                <label class="block text-sm font-medium mb-1 ">Sub Case Volume UOM</label>
                <select v-model="disForm.sub_case_volume_uom" class="w-full border px-3 py-2 rounded-lg">
                  <option value="">-- Select --</option>
                  <option v-for="uom in volume_uoms" :key="uom" :value="uom">{{ uom }}</option>
                </select>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">

              <div>
                <label class="block text-sm font-medium mb-1">Case Quantity</label>
                <input type="number" min="0" step="1" v-model="disForm.case_qty" class="w-full border px-3 py-2 rounded-lg">
              </div>

              <div>
                <label class="block text-sm font-medium mb-1">Sub Case Quantity</label>
                <input type="number" min="0" step="1" v-model="disForm.sub_case_qty" class="w-full border px-3 py-2 rounded-lg">
              </div>



            </div>
          </div>

        </div>


      </template>

      <template #footer>
        <div class="flex justify-end items-center">
          <button v-if="item_type === 'exist'" @click="sendToProductPage"
            class="inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase bg-red-500 text-white text-base">Attach</button>

          <button v-if="item_type === 'new'" @click="saveToDistributorItem"
            class="inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase bg-red-500 text-white text-base">Add
            & Attach </button>

          <button v-if="isCaseExist" @click="updateToDistributorItem"
            class="inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase bg-red-500 text-white text-base">Save</button>


        </div>
      </template>
    </jet-dialog-modal>
  </div>

</template>

<script>
import JetDialogModal from '@/Jetstream/DialogModal';
import axios from 'axios';
import { ajax } from 'jquery';
export default {
  name: "AttachDistributor",
  props: [
    'preferProduct', 'all_distributors', 'ind', 'prod'],
  components: {
    JetDialogModal,
  },
  data() {
    return {
      isDistributorModel: false,
      items: [],
      caseInfo: {},
      selectedDistributorId: '',
      item_type: 'new',
      weight_uoms: ['Ounce', 'Gram', 'LB', 'Kilogram', 'Milligram'],
      volume_uoms: ['Gallon', 'Quart', 'Pint', 'Cup', 'Fluid Ounce', 'Tablespoon', 'Teaspoon', 'Litre', 'Millilitre'],
      selectedItem: null,
      disForm: this.$inertia.form({
        id: '',
        distributor_id: this.preferProduct.distributor_id,
        product_id: this.preferProduct.product_id,
        item_number: '',
        mpc_code: '',
        case_qty: '',
        case_total: '',
        case_avg: '',
        case_weight: '',
        cost_per_lb: '',
        total_cases: '',
        upc: '',
        case_cost: '',
        sub_case_weight: '',
        sub_case_weight_uom: '',
        case_weight_uom: '',
        case_volume: '',
        case_volume_uom: '',
        sub_case_volume: '',
        sub_case_volume_uom: '',
        sub_case_qty: ''
      })
    };
  },
  computed: {
    isCaseExist() {
      if (!this.preferProduct || !this.preferProduct.distributors) {
        return false;
      }
      return Object.values(this.preferProduct.distributors).some(d => d.id === this.preferProduct.distributor_id);
    },
    getCaseinfo() {
      if (!this.isCaseExist) {
        return {};
      }
      if (!this.caseInfo || Object.keys(this.caseInfo).length === 0) {
        this.hideShowLoader('show');
        console.log('Fetching case info...', { distributor_id: this.preferProduct.distributor_id, product_id: this.preferProduct.product_id });
        axios.post('/get-case-info', { distributor_id: this.preferProduct.distributor_id, product_id: this.preferProduct.product_id })
          .then(response => {
            this.hideShowLoader('hide');

            this.caseInfo = response.data;
            this.formFill(response.data);
            return this.caseInfo;
          });
      } else {
        return this.caseInfo;
      }
    }
  },
  methods: {
    openCreateDistributorPopup() {
      this.isDistributorModel = true;
      this.caseInfo = {};
      this.items = [];
      this.disForm.reset();
      this.disForm.distributor_id = this.preferProduct.distributor_id;
      this.disForm.product_id = this.preferProduct.product_id;
      if (this.isCaseExist) {
        this.item_type = 'edit';
        let caseData = this.getCaseinfo;
      } else {
        this.item_type = 'new';
      }

    },

    getDistributorName() {
      let distributorId = this.preferProduct.distributor_id;
      const found = this.all_distributors.find(d => d.id === distributorId);
      return found ? found.name : 'Please select distributor';
    },

    getDistributorItems() {
      // Logic to get distributor data
      if (!this.preferProduct.distributor_id) {
        this.items = [];

        return;
      }
      this.hideShowLoader('show');
      axios.get(`/get-distributor-items/${this.preferProduct.distributor_id}`)
        .then(response => {
          this.hideShowLoader('hide');
          this.items = response.data;
        })
        .catch(error => {
          this.hideShowLoader('hide');
          console.error('Error fetching distributor items:', error);
        });
    },

    addDistributor() {
      let dis = this.all_distributors.find(d => d.id === this.preferProduct.distributor_id);
      if (dis) {
        let distributorData = {
          id: dis.id,
          name: dis.name,
          item_number: '',
          brand: '',
          case_avg: '',
          case_qty: '',
          distributor_products_id: '',
          pack: '',
          size: '',
          cost_per_lb: '',
          total_cases: '',
          case_weight: '',
          case_weight_uom: '',
          case_volume: '',
          case_volume_uom: '',
          sub_case_volume: '',
          sub_case_qty: '',
          case_cost: ''
        };
        this.preferProduct.distributors[this.preferProduct.distributor_id] = distributorData;
      }
    },
    sendToProductPage() {
      let itemData = this.selectedItem;
      this.formFill(itemData);
      console.log('Selected item data:', itemData);
      axios
        .post(route('add-distributor-to-product', { product: this.preferProduct.product_id }), {
          distributor_products: itemData
        })
        .then((response) => {
          console.log('Distributor item attached successfully:', response.data);
        })
        .catch((error) => console.error(error));
      this.addDistributor();
      this.caseInfo = itemData;
      this.updateDistributer();
      this.item_type = 'edit';
      this.closeDistributorPopup();
    },
    closeDistributorPopup() {
      this.item_type = 'new';
      this.isDistributorModel = false;
    },
    saveToDistributorItem() {
      // require validation
      if (!this.disForm.item_number || !this.disForm.case_weight || !this.disForm.case_weight_uom) {
        this.$toast.error('Please fill all required fields');
        return;
      }


      this.disForm.distributor_id = this.preferProduct.distributor_id;

      axios.post('/save-distributor-items', this.disForm).then((response) => {
        // console.log(responce);
        let itemData = response.data;
        axios
          .post(route('add-distributor-to-product', { product: this.preferProduct.product_id }), {
            distributor_products: itemData
          })
          .then((response) => {
            console.log('Distributor item attached successfully:', response.data);
          })
          .catch((error) => console.error(error));
        this.addDistributor();
        this.caseInfo = itemData;
        this.updateDistributer();
        this.item_type = 'edit';
        this.closeDistributorPopup();
      });
    },
    updateToDistributorItem() {
      // require validation
      // console.log(this.disForm);
      if (!this.disForm.item_number || !this.disForm.case_weight || !this.disForm.case_weight_uom) {
        this.$toast.error('Please fill all required fields');
        return;
      }
      this.hideShowLoader('show');
      this.disForm.id = this.caseInfo.id;
      axios.post('/update-distributor-items', this.disForm).then((response) => {
        let itemData = response.data;
        console.log('Updated item data:', itemData);
        this.formFill(itemData);
        this.hideShowLoader('hide');
        this.$toast.success('Case info updated successfully');
        this.updateDistributer();
        this.closeDistributorPopup();
      });
    },
    hideShowLoader(types) {
      if (types == 'show') {
        document.getElementById('full_loader').style.display = 'flex';
      } else {
        document.getElementById('full_loader').style.display = 'none';
      }
    },
    formFill(data) {
      this.caseInfo = data;
      this.disForm.item_number = this.caseInfo.item_number;
      this.disForm.pack = this.caseInfo.pack;
      this.disForm.size = this.caseInfo.size;
      this.disForm.brand = this.caseInfo.brand;
      this.disForm.description = this.caseInfo.description;
      this.disForm.mpc_code = this.caseInfo.mpc_code;
      this.disForm.case_qty = this.caseInfo.case_qty;
      this.disForm.case_total = this.caseInfo.case_total;
      this.disForm.case_avg = this.caseInfo.case_avg;
      this.disForm.case_weight = this.caseInfo.case_weight;
      this.disForm.cost_per_lb = this.caseInfo.cost_per_lb;
      this.disForm.total_cases = this.caseInfo.total_cases;
      this.disForm.upc = this.caseInfo.upc;
      this.disForm.case_cost = this.caseInfo.case_cost;
      this.disForm.sub_case_weight = this.caseInfo.sub_case_weight;
      this.disForm.sub_case_weight_uom = this.caseInfo.sub_case_weight_uom;
      this.disForm.case_weight_uom = this.caseInfo.case_weight_uom;
      this.disForm.case_volume = this.caseInfo.case_volume;
      this.disForm.case_volume_uom = this.caseInfo.case_volume_uom;
      this.disForm.sub_case_volume = this.caseInfo.sub_case_volume;
      this.disForm.sub_case_volume_uom = this.caseInfo.sub_case_volume_uom;
      this.disForm.sub_case_qty = this.caseInfo.sub_case_qty;
      this.disForm.id = this.caseInfo.id;
      this.disForm.distributor_id = this.preferProduct.distributor_id;
      this.disForm.product_id = this.preferProduct.product_id;
    },
    updateDistributer() {

      this.preferProduct.distributors[this.preferProduct.distributor_id].item_number = this.caseInfo.item_number;
      // this.preferProduct.distributors[this.preferProduct.distributor_id].brand = this.caseInfo.brand;
      // this.preferProduct.distributors[this.preferProduct.distributor_id].case_avg = this.caseInfo.case_avg;
      this.preferProduct.distributors[this.preferProduct.distributor_id].case_qty = this.caseInfo.case_qty;
      this.preferProduct.distributors[this.preferProduct.distributor_id].distributor_products_id = this.caseInfo.id;
      // this.preferProduct.distributors[this.preferProduct.distributor_id].pack = this.caseInfo.pack;
      // this.preferProduct.distributors[this.preferProduct.distributor_id].size = this.caseInfo.size;
      this.preferProduct.distributors[this.preferProduct.distributor_id].cost_per_lb = this.caseInfo.cost_per_lb;
      this.preferProduct.distributors[this.preferProduct.distributor_id].total_cases = this.caseInfo.total_cases;
      this.preferProduct.distributors[this.preferProduct.distributor_id].upc = this.caseInfo.upc;
      this.preferProduct.distributors[this.preferProduct.distributor_id].case_cost = this.caseInfo.case_cost;
      this.preferProduct.distributors[this.preferProduct.distributor_id].sub_case_weight = this.caseInfo.sub_case_weight;
      this.preferProduct.distributors[this.preferProduct.distributor_id].sub_case_weight_uom = this.caseInfo.sub_case_weight_uom;
      this.preferProduct.distributors[this.preferProduct.distributor_id].case_weight_uom = this.caseInfo.case_weight_uom;
      this.preferProduct.distributors[this.preferProduct.distributor_id].sub_case_weight_uom = this.caseInfo.sub_case_weight_uom;
      this.preferProduct.distributors[this.preferProduct.distributor_id].sub_case_volume_uom = this.caseInfo.sub_case_volume_uom;


      this.preferProduct.distributors[this.preferProduct.distributor_id].case_volume = this.caseInfo.case_volume;
      this.preferProduct.distributors[this.preferProduct.distributor_id].case_volume_uom = this.caseInfo.case_volume_uom;
      this.preferProduct.distributors[this.preferProduct.distributor_id].sub_case_volume = this.caseInfo.sub_case_volume;
      this.preferProduct.distributors[this.preferProduct.distributor_id].sub_case_volume_uom = this.caseInfo.sub_case_volume_uom;
      this.preferProduct.distributors[this.preferProduct.distributor_id].sub_case_qty = this.caseInfo.sub_case_qty;

      this.$emit('update-distributors', this.ind, this.prod, this.preferProduct.product_id, this.preferProduct.distributors[this.preferProduct.distributor_id]);

    }
  }
}
</script>
